import { Language } from './Language';
import { MainMenu } from './MainMenu';

export const sidebarPanels = {
  main: <MainMenu />,
  lang: <Language />,
  // language:
};

export type SidebarPanel = keyof typeof sidebarPanels;
